module.exports = __webpack_public_path__ + "static/BigHealth-b5656d92f316176c43d7dbddc8f70025.jpg";